import { Button } from '@cimpress/react-components';
import React from 'react';

interface Props {
  hide: () => void;
}

const showCannotDeleteTruckComponent = ({ hide } : Props) => {
  return (
    <div>
      <h3 style={{ marginBottom: '30px' }}>
        Truck cannot be deleted because it has pallet boxes with shipments
      </h3>
      <Button onClick={() => hide()}>
        Close
      </Button>
    </div>
  );
};

export default showCannotDeleteTruckComponent;
